import { QueryClient, QueryCache } from '@tanstack/react-query';

const queryConfig = {
	queries: {
		// useErrorBoundary: true,
		refetchOnWindowFocus: false,
		retry: false,
	},
};

export const queryClient = new QueryClient({
	defaultOptions: queryConfig,
});
